import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button, Row, Col, Grid } from "react-bootstrap";

import Sidebar from "../../Sidebar/Sidebar";
import BannerRectangleLarge from "../../Banner/BannerRectangleLarge";
import OSCard from "../../OSCard/OSCard";


const props_json = {
  display: "inline-block",
  margin: "15px",
  width: "223px",
  verticalAlign: "top",
  border: "1px solid #edeeee "
};

const propsouter_json = {
  display: "inline-block"
};

const img_json = {
  width: "100%",
  height: "200px",
  cursor: "pointer"
};

const places = {
  fontSize: "16px",
  fontWeight: "bold",
  color: "rgb(41,63,84)",
  display: "block"
};

const pd_spaces = {
  padding: "10px",
  borderTop: "1px solid #edeeee "
};

const exp_text = {
  color: "rgb(41,63,84)",
  fontSize: "14px"
};

class HomeEvents extends Component {
  render() {
    const { events, language } = this.props.events;
    return (
      <Row>
        {events.length > 0 &&
          events.map(event => {
            return (
            <Col xs={12} sm={6} lg={4} key={event.id}>
              <OSCard
                key={event.id}
                id={event.id}
                image={event.imageUrl}
                title={event.eventName}
                link={event.link}
                startDate={event.eventVenues[0].startDate}
                endDate={event.eventVenues[0].endDate}
                venueName={event.eventVenues[0].venueName}
                description={event.description}
                lat={event.eventVenues[0].latitude}
                lng={event.eventVenues[0].longitude}
                language={language}
                
              />
            </Col>
            );
          })}
      </Row>
    );
  }
}

export default HomeEvents;



// WEBPACK FOOTER //
// ./src/components/Pages/Home/HomeEvents.js